import { Typography } from '@breetometer/components';

import type { IFileError } from '../../FileInput/FileInput.helpers';

export const FilePreviewError = ({ error, onReload }: IFileError) => (
	<div className='error-state'>
		<Typography as='p'>❌ {error}</Typography>
		<button
			onClick={onReload}
			type='button'
		>
			Try Again
		</button>
	</div>
);
